export const environment = {
  production: false,
  authServiceUrl: 'https://hub-keycloak.demo.irembolabs.com/',
  authRealm: 'irembo',
  authClientId: 'service-management-portal',
  authSuccessRedirectUrl: 'https://service-portal.demo.irembolabs.com',
  apiGatewayBaseUrl: 'https://service-gateway.demo.irembolabs.com',
  enableKeycloakMockService: false,
  citizenApiGatewayBaseUrl: 'https://citizen-gateway.demo.irembolabs.com',
  DEFAULT_LOCALE: 'en-US',
  translationSourceUrl: 'https://service-gateway.demo.irembolabs.com',
  mockBaseUrl: 'https://service-gateway.demo.irembolabs.com',
  testPortalUrls: {
    citizen: 'https://citizen-portal.demo.irembolabs.com',
    iremboPlus: 'https://iremboplus.demo.irembolabs.com',
    rdbOsc: 'https://osc-portal.demo.irembolabs.com',
  },
};
